import React from "react";
import { FcAlarmClock, FcCalendar, FcList } from "react-icons/fc";
import { dateFormate } from "util/Util";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function EventInfo({ selectedEvent, projects, handleEdit, handleDelete }: any) {
  console.log("Selected Event: ", selectedEvent);
  // Prefer the projectName carried on the event itself; fall back to looking it
  // up in the assigned-projects list only when the event doesn't have it. This
  // avoids the crash when `data[0]` is undefined (project not in `projects`).
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const matchedProject = (projects || []).find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (project: any) => project.projectId === selectedEvent.projectId
  );
  const projectName =
    selectedEvent.projectName || matchedProject?.name || "—";

  return (
    <div className="">
      <div className="flex items-center justify-between">
        <div />
        <div className="flex flex-row gap-2">
          {/* Edit Button - Solid blue background and white icon on hover */}
          <button
            onClick={() => {
              console.log("handleEdit called with:", selectedEvent);
              handleEdit(selectedEvent);
            }}
            className="group p-1.5 flex items-center justify-center bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-md hover:bg-blue-600 hover:border-blue-600 dark:hover:bg-blue-600 dark:hover:border-blue-600 transition-colors shadow-sm cursor-pointer"
            title="Edit"
          >
            <FaEdit size={16} className="text-blue-600 dark:text-blue-400 group-hover:text-white dark:group-hover:text-white group-hover:scale-110 transition-all" />
          </button>

          {/* Delete Button */}
          <button
            onClick={() => {
              handleDelete(selectedEvent.id);
            }}
            className="group p-1.5 flex items-center justify-center bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-md hover:bg-red-50 dark:hover:bg-red-500/10 transition-colors shadow-sm cursor-pointer"
            title="Delete"
          >
            <FaRegTrashAlt size={16} className="text-error group-hover:scale-110 transition-transform" />
          </button>
        </div>
      </div>

      <p className="text-l text-gray-600 flex items-center mb-2 dark:text-white">
        <FcList size={20} className="me-2" /> Project Name : {projectName}
      </p>
      <p className="text-l text-gray-600 flex items-center mb-2 dark:text-white">
        <FcAlarmClock size={20} className="me-2" /> Hours : {selectedEvent.hour}
      </p>
      <p className="text-l text-gray-600 flex items-center  mb-2 dark:text-white">
        <FcCalendar size={20} className="me-2" /> Date :{" "}
        {dateFormate(selectedEvent.start)}
      </p>
      <div className="flex items-center justify-between mb-4">
        <textarea
          rows={4}
          className="block p-2.5 w-full text-lg text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
          value={selectedEvent.title}
          disabled
        />
      </div>
      <p className="text-gray-600 truncate">{selectedEvent.description}</p>
    </div>
  );
}

export default React.memo(EventInfo);